import {
  TextFormatting,
  type IMenuButton,
  BlockNodes,
} from '@principle-theorem/editor';
import { type MenuButtonLoaderFn } from '@principle-theorem/ng-prosemirror';
import { BasicMenuButtonComponent } from '../../menu-bar/basic-menu-button/basic-menu-button.component';

export const BOLD_KEYMAP = 'Mod-b';

export function createBoldMenuButton(): MenuButtonLoaderFn<
  BasicMenuButtonComponent,
  IMenuButton
> {
  return () => ({
    component: BasicMenuButtonComponent,
    data: {
      buttonType: 'basic',
      buttonText: 'Bold',
      tooltip: 'Bold',
      shortcut: BOLD_KEYMAP,
      icon: 'format_bold',
      command: (editor) => editor.chain().focus().toggleBold().run(),
      isActiveFn: (editor) => editor.isActive(TextFormatting.Bold),
      canActivateFn: (editor) => editor.isActive(BlockNodes.Paragraph),
    },
  });
}
